export default __webpack_public_path__ + "static/TEnImfmv-54b96ae16e6a494725cdfaf7de34cb91.jpeg";